export default __webpack_public_path__ + "static/media/HKFWS.d589723f.png";